import * as t from "io-ts";

import fetchApi from "ui-io/fetch-api";

const TaskEventMutationResultIO = t.array(
  t.union([
    t.intersection([
      t.type({
        success: t.type({
          task_id: t.string,
        }),
      }),
      t.partial({
        radar: t.string,
      }),
    ]),
    t.type({
      failure: t.string,
    }),
  ])
);

export const taskBlockMutation = ({
  taskIds,
  radar,
  comment,
  reasons,
  createRadar,
}: {
  taskIds: string[];
  radar?: string;
  comment?: string;
  reasons?: { [reason: string]: string }[];
  createRadar?: boolean;
}) =>
  fetchApi({
    service: "admin-service",
    method: "POST",
    pathname: `/tasks/_block`,
    body: {
      taskIds,
      radar,
      comment,
      reasons,
      createRadar,
    },
    codec: TaskEventMutationResultIO,
  });

export const taskUnblockMutation = ({ taskIds }: { taskIds: string[] }) =>
  fetchApi({
    service: "admin-service",
    method: "POST",
    pathname: `/tasks/_unblock`,
    body: taskIds,
    codec: TaskEventMutationResultIO,
  });
